// import React, { useCallback, useEffect, useRef, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import "./CottonParatha.css";

// const TABS = [
//   {
//     key: "new-launches",
//     label: "New Launches",
//     products: [
//       {
//         id: "nl-1",
//         name: "Kanak Jaal Banarasi Silk Checks Saree",
//         price: 3375,
//         oldPrice: 5250,
//         images: [
//           "/img/launch1.jxl",
//           "/img/launch2.webp",
//         ],
//         link: "/products?category=2&subcategory=1",
//       },
//       {
//         id: "nl-2",
//         name: "Shabnam Cotton Silk Saree",
//         price: 3999,
//         oldPrice: 5950,
//         images: [
//           "/img/scrollsec9.webp",
//           "/img/scrollsec10.webp",
//         ],
//         link: "/products?category=2&subcategory=2",
//       },
//       {
//         id: "nl-3",
//         name: "Dhoop Rani Tussar Silk Banarasi Saree",
//         price: 3750,
//         oldPrice: 5650,
//         images: [
//           "/img/launch3.webp",
//           "/img/launch4.webp",
//         ],
//         link: "/products?category=2&subcategory=3",
//       },
//       {
//         id: "nl-4",
//         name: "Sunehri Chauka Banarasi Silk Checks Saree",
//         price: 3875,
//         oldPrice: 5799,
//         images: [
//           "/img/launch5.webp",
//           "/img/launch6.webp",
//         ],
//         link: "/products?category=2&subcategory=4",
//       },
//       {
//         id: "nl-5",
//         name: "Gulabi Zari Banarasi Silk Saree",
//         price: 4250,
//         oldPrice: 6300,
//         images: [
//           "/img/launch7.webp",
//           "/img/launch8.webp",
//         ],
//         link: "/products?category=2&subcategory=5",
//       },
//       {
//         id: "nl-6",
//         name: "Neelam Tissue Silk Saree",
//         price: 3650,
//         oldPrice: 5400,
//         images: [
//           "/img/launch9.webp",
//           "/img/launch10.webp",
//         ],
//         link: "/products?category=2&subcategory=6",
//       },
//       {
//         id: "nl-7",
//         name: "Kesariya Maheshwari Silk Saree",
//         price: 4100,
//         oldPrice: 6100,
//         images: [
//           "/img/launch11.webp",
//           "/img/launch12.webp",
//         ],
//         link: "/products?category=2&subcategory=7",
//       },
//       {
//         id: "nl-8",
//         name: "Hara Bhara Kota Silk Saree",
//         price: 3450,
//         oldPrice: 5100,
//         images: [
//           "/img/launch13.webp",
//           "/img/launch14.webp",
//         ],
//         link: "/products?category=2&subcategory=8",
//       },
//     ],
//   },
//   {
//     key: "cotton-sarees",
//     label: "Cotton Sarees",
//     products: [
//       {
//         id: "cs-1",
//         name: "Mehndi Dot Print Cotton Saree",
//         price: 1899,
//         oldPrice: 2899,
//         images: [
//           "https://placehold.co/800x1066/a8b030/2b3a34?text=Mehndi+Dot",
//           "https://placehold.co/800x1066/8f972a/2b3a34?text=Mehndi+Dot+2",
//         ],
//         link: "/products?category=2&subcategory=11",
//       },
//       {
//         id: "cs-2",
//         name: "Neel Kamal Hand Painted Mulmul Saree",
//         price: 2499,
//         oldPrice: 3799,
//         images: [
//           "https://placehold.co/800x1066/2a2b6b/fffbf7?text=Neel+Kamal",
//           "https://placehold.co/800x1066/1d1e52/fffbf7?text=Neel+Kamal+2",
//         ],
//         link: "/products?category=2&subcategory=12",
//       },
//       {
//         id: "cs-3",
//         name: "Lal Kota Cotton Saree",
//         price: 2199,
//         oldPrice: 3299,
//         images: [
//           "https://placehold.co/800x1066/b4442f/fffbf7?text=Lal+Kota",
//           "https://placehold.co/800x1066/973521/fffbf7?text=Lal+Kota+2",
//         ],
//         link: "/products?category=2&subcategory=13",
//       },
//       {
//         id: "cs-4",
//         name: "Sundari Handloom Cotton Saree",
//         price: 1999,
//         oldPrice: 2999,
//         images: [
//           "https://placehold.co/800x1066/c9b99a/2b3a34?text=Sundari",
//           "https://placehold.co/800x1066/b3a182/2b3a34?text=Sundari+2",
//         ],
//         link: "/products?category=2&subcategory=14",
//       },
//       {
//         id: "cs-5",
//         name: "Pushpa Floral Cotton Saree",
//         price: 1799,
//         oldPrice: 2699,
//         images: [
//           "https://placehold.co/800x1066/7a3f5e/fffbf7?text=Pushpa",
//           "https://placehold.co/800x1066/602e49/fffbf7?text=Pushpa+2",
//         ],
//         link: "/products?category=2&subcategory=15",
//       },
//       {
//         id: "cs-6",
//         name: "Kesar Checks Linen Cotton Saree",
//         price: 2299,
//         oldPrice: 3399,
//         images: [
//           "https://placehold.co/800x1066/d8a65a/2b3a34?text=Kesar+Checks",
//           "https://placehold.co/800x1066/c08f43/2b3a34?text=Kesar+Checks+2",
//         ],
//         link: "/products?category=2&subcategory=16",
//       },
//       {
//         id: "cs-7",
//         name: "Haritima Block Print Cotton Saree",
//         price: 1699,
//         oldPrice: 2599,
//         images: [
//           "https://placehold.co/800x1066/3d5a4a/fffbf7?text=Haritima",
//           "https://placehold.co/800x1066/2b3a34/fffbf7?text=Haritima+2",
//         ],
//         link: "/products?category=2&subcategory=17",
//       },
//       {
//         id: "cs-8",
//         name: "Gulmohar Ikat Cotton Saree",
//         price: 2399,
//         oldPrice: 3599,
//         images: [
//           "https://placehold.co/800x1066/c4572f/fffbf7?text=Gulmohar",
//           "https://placehold.co/800x1066/a64522/fffbf7?text=Gulmohar+2",
//         ],
//         link: "/products?category=2&subcategory=18",
//       },
//     ],
//   },
// ];

// const formatPrice = (value) =>
//   `Rs. ${Number(value).toLocaleString("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   })}`;

// /* ---------------------------- ICONS ---------------------------- */
// const PlusIcon = () => (
//   <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
//     <path d="M12 5v14M5 12h14" />
//   </svg>
// );

// const MinusIcon = () => (
//   <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
//     <path d="M5 12h14" />
//   </svg>
// );

// const ChevronIcon = ({ dir = "right" }) => (
//   <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ transform: dir === "left" ? "scaleX(-1)" : "none" }}>
//     <path d="M9 5l7 7-7 7" />
//   </svg>
// );

// const CloseIcon = () => (
//   <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
//     <path d="M5 5l14 14M19 5L5 19" />
//   </svg>
// );

// /* --------------------------- COMPONENT -------------------------- */
// const CottonParatha = () => {
//   const navigate = useNavigate();

//   const [activeTab, setActiveTab] = useState(0);
//   const [canPrev, setCanPrev] = useState(false);
//   const [canNext, setCanNext] = useState(true);

//   const [cartOpen, setCartOpen] = useState(false);
//   const [cartItems, setCartItems] = useState([]);
//   const [showNote, setShowNote] = useState(false);
//   const [orderNote, setOrderNote] = useState("");

//   const trackRef = useRef(null);
//   const headerRef = useRef(null);

//   const products = TABS[activeTab].products;

//   /* ---------------- Carousel arrows state ---------------- */
//   const updateArrows = useCallback(() => {
//     const el = trackRef.current;
//     if (!el) return;
//     setCanPrev(el.scrollLeft > 4);
//     setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
//   }, []);

//   useEffect(() => {
//     const el = trackRef.current;
//     if (!el) return;
//     el.scrollTo({ left: 0 });
//     updateArrows();

//     window.addEventListener("resize", updateArrows);
//     return () => window.removeEventListener("resize", updateArrows);
//   }, [activeTab, updateArrows]);

//   const scrollByPage = (direction) => {
//     const el = trackRef.current;
//     if (!el) return;
//     el.scrollBy({ left: direction * (el.clientWidth + 24), behavior: "smooth" });
//   };

//   /* ---------------- Heading fade-in on scroll ---------------- */
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("cottonparatha-animate-in");
//             observer.unobserve(entry.target);
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );
//     if (headerRef.current) observer.observe(headerRef.current);
//     return () => observer.disconnect();
//   }, []);

//   /* ---------------- Cart drawer ---------------- */
//   // Body scroll lock + Esc se close
//   useEffect(() => {
//     if (!cartOpen) return;
//     const prevOverflow = document.body.style.overflow;
//     document.body.style.overflow = "hidden";
//     const onKey = (e) => e.key === "Escape" && setCartOpen(false);
//     document.addEventListener("keydown", onKey);
//     return () => {
//       document.body.style.overflow = prevOverflow;
//       document.removeEventListener("keydown", onKey);
//     };
//   }, [cartOpen]);

//   /* Plus button click: product cart mein add + drawer open.
//      Real cart API se jodna ho to yahan apna add-to-cart call laga dena. */
//   const handleAddToCart = (product) => {
//     setCartItems((prev) => {
//       const exists = prev.find((item) => item.id === product.id);
//       if (exists) {
//         return prev.map((item) =>
//           item.id === product.id ? { ...item, qty: item.qty + 1 } : item
//         );
//       }
//       return [
//         ...prev,
//         {
//           id: product.id,
//           name: product.name,
//           price: product.price,
//           image: product.images[0],
//           qty: 1,
//         },
//       ];
//     });
//     setCartOpen(true);
//   };

//   const changeQty = (id, delta) => {
//     setCartItems((prev) =>
//       prev.map((item) =>
//         item.id === id ? { ...item, qty: Math.max(1, item.qty + delta) } : item
//       )
//     );
//   };

//   const removeItem = (id) => {
//     setCartItems((prev) => prev.filter((item) => item.id !== id));
//   };

//   const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.qty, 0);

//   const handleCheckout = () => {
//     setCartOpen(false);
//     navigate("/bag");
//   };

//   return (
//     <section className="cottonparatha-section">
//       <div className="cottonparatha-container">
//         {/* Tabs heading */}
//         <div className="cottonparatha-header" ref={headerRef} role="tablist">
//           {TABS.map((tab, index) => (
//             <button
//               key={tab.key}
//               type="button"
//               role="tab"
//               aria-selected={activeTab === index}
//               className={`cottonparatha-tab ${
//                 activeTab === index ? "cottonparatha-tab-active" : ""
//               }`}
//               onClick={() => setActiveTab(index)}
//             >
//               <span className="cottonparatha-tab-text">{tab.label}</span>
//             </button>
//           ))}
//         </div>

//         {/* Carousel */}
//         <div className="cottonparatha-carousel">
//           <button
//             type="button"
//             className={`cottonparatha-arrow cottonparatha-arrow-prev ${
//               canPrev ? "cottonparatha-arrow-show" : ""
//             }`}
//             aria-label="Previous products"
//             onClick={() => scrollByPage(-1)}
//             tabIndex={canPrev ? 0 : -1}
//           >
//             <ChevronIcon dir="left" />
//           </button>

//           <div
//             className="cottonparatha-track"
//             ref={trackRef}
//             onScroll={updateArrows}
//           >
//             {products.map((product) => (
//               <article className="cottonparatha-card" key={product.id}>
//                 <div className="cottonparatha-media">
//                   <Link
//                     to={product.link}
//                     className="cottonparatha-media-link"
//                     aria-label={product.name}
//                   >
//                     <img
//                       src={product.images[0]}
//                       alt={product.name}
//                       className="cottonparatha-img cottonparatha-img-main"
//                       loading="lazy"
//                       draggable={false}
//                     />
//                     {product.images[1] && (
//                       <img
//                         src={product.images[1]}
//                         alt=""
//                         className="cottonparatha-img cottonparatha-img-hover"
//                         loading="lazy"
//                         draggable={false}
//                       />
//                     )}
//                   </Link>

//                   <button
//                     type="button"
//                     className="cottonparatha-plus"
//                     aria-label={`Add ${product.name} to cart`}
//                     onClick={() => handleAddToCart(product)}
//                   >
//                     <PlusIcon />
//                   </button>
//                 </div>

//                 <Link to={product.link} className="cottonparatha-info">
//                   <h3 className="cottonparatha-name">{product.name}</h3>
//                   <p className="cottonparatha-price">
//                     <span>{formatPrice(product.price)}</span>
//                     <s>{formatPrice(product.oldPrice)}</s>
//                   </p>
//                 </Link>
//               </article>
//             ))}
//           </div>

//           <button
//             type="button"
//             className={`cottonparatha-arrow cottonparatha-arrow-next ${
//               canNext ? "cottonparatha-arrow-show" : ""
//             }`}
//             aria-label="Next products"
//             onClick={() => scrollByPage(1)}
//             tabIndex={canNext ? 0 : -1}
//           >
//             <ChevronIcon dir="right" />
//           </button>
//         </div>
//       </div>

//       {/* ---------------- CART DRAWER ---------------- */}
//       <div
//         className={`cottonparatha-overlay ${cartOpen ? "cottonparatha-open" : ""}`}
//         onClick={() => setCartOpen(false)}
//         aria-hidden={!cartOpen}
//       />

//       <aside
//         className={`cottonparatha-drawer ${cartOpen ? "cottonparatha-open" : ""}`}
//         aria-label="Cart"
//         aria-hidden={!cartOpen}
//       >
//         <div className="cottonparatha-drawer-head">
//           <h4>Cart</h4>
//           <button
//             type="button"
//             className="cottonparatha-drawer-close"
//             aria-label="Close cart"
//             onClick={() => setCartOpen(false)}
//             tabIndex={cartOpen ? 0 : -1}
//           >
//             <CloseIcon />
//           </button>
//         </div>

//         <div className="cottonparatha-drawer-body">
//           {cartItems.length === 0 ? (
//             <p className="cottonparatha-empty">Your cart is empty.</p>
//           ) : (
//             cartItems.map((item) => (
//               <div className="cottonparatha-cart-item" key={item.id}>
//                 <img src={item.image} alt={item.name} />

//                 <div className="cottonparatha-cart-info">
//                   <p className="cottonparatha-cart-name">{item.name}</p>
//                   <p className="cottonparatha-cart-price">{formatPrice(item.price)}</p>

//                   <div className="cottonparatha-cart-actions">
//                     <div className="cottonparatha-qty">
//                       <button
//                         type="button"
//                         aria-label="Decrease quantity"
//                         onClick={() => changeQty(item.id, -1)}
//                         tabIndex={cartOpen ? 0 : -1}
//                       >
//                         <MinusIcon />
//                       </button>
//                       <span>{item.qty}</span>
//                       <button
//                         type="button"
//                         aria-label="Increase quantity"
//                         onClick={() => changeQty(item.id, 1)}
//                         tabIndex={cartOpen ? 0 : -1}
//                       >
//                         <PlusIcon />
//                       </button>
//                     </div>

//                     <button
//                       type="button"
//                       className="cottonparatha-remove"
//                       onClick={() => removeItem(item.id)}
//                       tabIndex={cartOpen ? 0 : -1}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>

//         <div className="cottonparatha-drawer-foot">
//           <button
//             type="button"
//             className="cottonparatha-note-toggle"
//             onClick={() => setShowNote((p) => !p)}
//             tabIndex={cartOpen ? 0 : -1}
//           >
//             Add order note
//           </button>

//           {showNote && (
//             <textarea
//               className="cottonparatha-note"
//               rows={3}
//               placeholder="Write your note here..."
//               value={orderNote}
//               onChange={(e) => setOrderNote(e.target.value)}
//             />
//           )}

//           <p className="cottonparatha-tax">Taxes and shipping calculated at checkout</p>

//           <div className="cottonparatha-subtotal">
//             <strong>Subtotal:</strong>
//             <strong>{formatPrice(subtotal)}</strong>
//           </div>

//           <button
//             type="button"
//             className="cottonparatha-checkout"
//             onClick={handleCheckout}
//             disabled={cartItems.length === 0}
//             tabIndex={cartOpen ? 0 : -1}
//           >
//             Checkout
//           </button>
//         </div>
//       </aside>
//     </section>
//   );
// };

// export default CottonParatha;








// 04-11-2026 dyanamic code
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./CottonParatha.css";

/* ⚠️ New Launches ka asli endpoint yahan daalo (jo LaunchParatha mein use kiya wahi) */
const NEW_LAUNCH_API = "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_z_new_launches"; // <-- apna endpoint
const COTTON_API = "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_z_cotton_saree";

/* Tabs static hain, sirf products API se aate hain.
   linkPrefix: card click par kahan jaye (/<prefix>/<id>) */
const TABS = [
  { key: "new-launches", label: "New Launches", api: NEW_LAUNCH_API, linkPrefix: "/launch-product" },
  { key: "cotton-sarees", label: "Cotton Sarees", api: COTTON_API, linkPrefix: "/cotton-product" },
];

const formatPrice = (value) =>
  `Rs. ${Number(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

/* API item -> card ka shape */
const mapProduct = (item, tab) => {
  // let hover = null;
  // if (Array.isArray(item.hover_image_urls) && item.hover_image_urls.length) {
  //   hover = item.hover_image_urls[0];
  // } else if (typeof item.hover_image_url === "string" && item.hover_image_url) {
  //   hover = item.hover_image_url;
  // }

  // const images = [item.image_url];
  // if (hover) images.push(hover);

    let hover = null;
  if (Array.isArray(item.hover_image_urls) && item.hover_image_urls.length) {
    hover = item.hover_image_urls[0];
  } else if (typeof item.hover_image_url === "string" && item.hover_image_url) {
    hover = item.hover_image_url;
  } else if (typeof item.hover_image === "string" && item.hover_image) {
    hover = item.hover_image; // Cotton API: seedha URL
  }

  const mainImage = item.image_url || item.image; // Cotton API: image mein URL
  const images = [mainImage];
  if (hover) images.push(hover);

  return {
    id: `${tab.key}-${item.id}`, // tabs ke beech id conflict na ho (cart ke liye)
    name: item.heading,
    price: Number(item.current_price),
    oldPrice: Number(item.old_price),
    images,
    // link: `${tab.linkPrefix}/${item.id}`,
    link: item.product_slug ? `/product/${item.product_slug}` : "/all-sarees",
  };
};

const fetchTabProducts = async (tab, signal) => {
  const res = await fetch(tab.api, { signal });
  if (!res.ok) throw new Error("Network response was not ok");
  const json = await res.json();

  // const ok =
  //   json?.success === "1" ||
  //   json?.success === 1 ||
  //   json?.status === "true" ||
  //   json?.status === true;

    const ok =
    json?.success === "1" ||
    json?.success === 1 ||
    json?.status === "true" ||
    json?.status === true ||
    json?.status === "success";
  if (!ok || !json.data) throw new Error(json?.message || "Failed to load products");

  const list = Array.isArray(json.data) ? json.data : [json.data];

  // A -> B: admin se jo pehla add hua wo pehle card par
  return [...list]
    .sort((a, b) => Number(a.id) - Number(b.id))
    .map((item) => mapProduct(item, tab));
};

/* ---------------------------- ICONS ---------------------------- */
const PlusIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

const MinusIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
    <path d="M5 12h14" />
  </svg>
);

const ChevronIcon = ({ dir = "right" }) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ transform: dir === "left" ? "scaleX(-1)" : "none" }}>
    <path d="M9 5l7 7-7 7" />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
    <path d="M5 5l14 14M19 5L5 19" />
  </svg>
);

/* --------------------------- COMPONENT -------------------------- */
const CottonParatha = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(0);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  // { "new-launches": { loading, error, products }, ... }
  const [tabData, setTabData] = useState(() =>
    TABS.reduce((acc, tab) => {
      acc[tab.key] = { loading: true, error: "", products: [] };
      return acc;
    }, {})
  );

  const [cartOpen, setCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [showNote, setShowNote] = useState(false);
  const [orderNote, setOrderNote] = useState("");

  const trackRef = useRef(null);
  const headerRef = useRef(null);

  const current = tabData[TABS[activeTab].key];
  const products = current.products;

  /* ---------------- API fetch (dono tabs ek saath) ---------------- */
  useEffect(() => {
    const controller = new AbortController();

    TABS.forEach(async (tab) => {
      try {
        const list = await fetchTabProducts(tab, controller.signal);
        setTabData((prev) => ({
          ...prev,
          [tab.key]: { loading: false, error: "", products: list },
        }));
      } catch (err) {
        if (err.name === "AbortError") return;
        setTabData((prev) => ({
          ...prev,
          [tab.key]: {
            loading: false,
            error: "Something went wrong while loading products.",
            products: [],
          },
        }));
      }
    });

    return () => controller.abort();
  }, []);

  /* ---------------- Carousel arrows state ---------------- */
  const updateArrows = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    setCanPrev(el.scrollLeft > 4);
    setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  }, []);

  useEffect(() => {
    const el = trackRef.current;
    if (el) el.scrollTo({ left: 0 });
    updateArrows();

    window.addEventListener("resize", updateArrows);
    return () => window.removeEventListener("resize", updateArrows);
  }, [activeTab, products, updateArrows]);

  const scrollByPage = (direction) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * (el.clientWidth + 24), behavior: "smooth" });
  };

  /* ---------------- Heading fade-in on scroll ---------------- */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("cottonparatha-animate-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (headerRef.current) observer.observe(headerRef.current);
    return () => observer.disconnect();
  }, []);

  /* ---------------- Cart drawer ---------------- */
  // Body scroll lock + Esc se close
  useEffect(() => {
    if (!cartOpen) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && setCartOpen(false);
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", onKey);
    };
  }, [cartOpen]);

  /* Plus button click: product cart mein add + drawer open.
     Real cart API se jodna ho to yahan apna add-to-cart call laga dena. */
  const handleAddToCart = (product) => {
    setCartItems((prev) => {
      const exists = prev.find((item) => item.id === product.id);
      if (exists) {
        return prev.map((item) =>
          item.id === product.id ? { ...item, qty: item.qty + 1 } : item
        );
      }
      return [
        ...prev,
        {
          id: product.id,
          name: product.name,
          price: product.price,
          image: product.images[0],
          qty: 1,
        },
      ];
    });
    setCartOpen(true);
  };

  const changeQty = (id, delta) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, qty: Math.max(1, item.qty + delta) } : item
      )
    );
  };

  const removeItem = (id) => {
    setCartItems((prev) => prev.filter((item) => item.id !== id));
  };

  const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.qty, 0);

  const handleCheckout = () => {
    setCartOpen(false);
    navigate("/bag");
  };

  return (
    <section className="cottonparatha-section">
      <div className="cottonparatha-container">
        {/* Tabs heading (static) */}
        <div className="cottonparatha-header" ref={headerRef} role="tablist">
          {TABS.map((tab, index) => (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={activeTab === index}
              className={`cottonparatha-tab ${
                activeTab === index ? "cottonparatha-tab-active" : ""
              }`}
              onClick={() => setActiveTab(index)}
            >
              <span className="cottonparatha-tab-text">{tab.label}</span>
            </button>
          ))}
        </div>

        {/* Loading / Error / Empty */}
        {current.loading && <p className="cottonparatha-empty">Loading...</p>}
        {!current.loading && current.error && (
          <p className="cottonparatha-empty">{current.error}</p>
        )}
        {!current.loading && !current.error && products.length === 0 && (
          <p className="cottonparatha-empty">No products available.</p>
        )}

        {/* Carousel */}
        {!current.loading && !current.error && products.length > 0 && (
          <div className="cottonparatha-carousel">
            <button
              type="button"
              className={`cottonparatha-arrow cottonparatha-arrow-prev ${
                canPrev ? "cottonparatha-arrow-show" : ""
              }`}
              aria-label="Previous products"
              onClick={() => scrollByPage(-1)}
              tabIndex={canPrev ? 0 : -1}
            >
              <ChevronIcon dir="left" />
            </button>

            <div
              className="cottonparatha-track"
              ref={trackRef}
              onScroll={updateArrows}
            >
              {products.map((product) => (
                <article className="cottonparatha-card" key={product.id}>
                  <div className="cottonparatha-media">
                    <Link
                      to={product.link}
                      className="cottonparatha-media-link"
                      aria-label={product.name}
                    >
                      <img
                        src={product.images[0]}
                        alt={product.name}
                        className="cottonparatha-img cottonparatha-img-main"
                        loading="lazy"
                        draggable={false}
                      />
                      {product.images[1] && (
                        <img
                          src={product.images[1]}
                          alt=""
                          className="cottonparatha-img cottonparatha-img-hover"
                          loading="lazy"
                          draggable={false}
                        />
                      )}
                    </Link>

                    <button
                      type="button"
                      className="cottonparatha-plus"
                      aria-label={`Add ${product.name} to cart`}
                      onClick={() => handleAddToCart(product)}
                    >
                      <PlusIcon />
                    </button>
                  </div>

                  <Link to={product.link} className="cottonparatha-info">
                    <h3 className="cottonparatha-name">{product.name}</h3>
                    <p className="cottonparatha-price">
                      <span>{formatPrice(product.price)}</span>
                      <s>{formatPrice(product.oldPrice)}</s>
                    </p>
                  </Link>
                </article>
              ))}
            </div>

            <button
              type="button"
              className={`cottonparatha-arrow cottonparatha-arrow-next ${
                canNext ? "cottonparatha-arrow-show" : ""
              }`}
              aria-label="Next products"
              onClick={() => scrollByPage(1)}
              tabIndex={canNext ? 0 : -1}
            >
              <ChevronIcon dir="right" />
            </button>
          </div>
        )}
      </div>

      {/* ---------------- CART DRAWER ---------------- */}
      <div
        className={`cottonparatha-overlay ${cartOpen ? "cottonparatha-open" : ""}`}
        onClick={() => setCartOpen(false)}
        aria-hidden={!cartOpen}
      />

      <aside
        className={`cottonparatha-drawer ${cartOpen ? "cottonparatha-open" : ""}`}
        aria-label="Cart"
        aria-hidden={!cartOpen}
      >
        <div className="cottonparatha-drawer-head">
          <h4>Cart</h4>
          <button
            type="button"
            className="cottonparatha-drawer-close"
            aria-label="Close cart"
            onClick={() => setCartOpen(false)}
            tabIndex={cartOpen ? 0 : -1}
          >
            <CloseIcon />
          </button>
        </div>

        <div className="cottonparatha-drawer-body">
          {cartItems.length === 0 ? (
            <p className="cottonparatha-empty">Your cart is empty.</p>
          ) : (
            cartItems.map((item) => (
              <div className="cottonparatha-cart-item" key={item.id}>
                <img src={item.image} alt={item.name} />

                <div className="cottonparatha-cart-info">
                  <p className="cottonparatha-cart-name">{item.name}</p>
                  <p className="cottonparatha-cart-price">{formatPrice(item.price)}</p>

                  <div className="cottonparatha-cart-actions">
                    <div className="cottonparatha-qty">
                      <button
                        type="button"
                        aria-label="Decrease quantity"
                        onClick={() => changeQty(item.id, -1)}
                        tabIndex={cartOpen ? 0 : -1}
                      >
                        <MinusIcon />
                      </button>
                      <span>{item.qty}</span>
                      <button
                        type="button"
                        aria-label="Increase quantity"
                        onClick={() => changeQty(item.id, 1)}
                        tabIndex={cartOpen ? 0 : -1}
                      >
                        <PlusIcon />
                      </button>
                    </div>

                    <button
                      type="button"
                      className="cottonparatha-remove"
                      onClick={() => removeItem(item.id)}
                      tabIndex={cartOpen ? 0 : -1}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="cottonparatha-drawer-foot">
          <button
            type="button"
            className="cottonparatha-note-toggle"
            onClick={() => setShowNote((p) => !p)}
            tabIndex={cartOpen ? 0 : -1}
          >
            Add order note
          </button>

          {showNote && (
            <textarea
              className="cottonparatha-note"
              rows={3}
              placeholder="Write your note here..."
              value={orderNote}
              onChange={(e) => setOrderNote(e.target.value)}
            />
          )}

          <p className="cottonparatha-tax">Taxes and shipping calculated at checkout</p>

          <div className="cottonparatha-subtotal">
            <strong>Subtotal:</strong>
            <strong>{formatPrice(subtotal)}</strong>
          </div>

          <button
            type="button"
            className="cottonparatha-checkout"
            onClick={handleCheckout}
            disabled={cartItems.length === 0}
            tabIndex={cartOpen ? 0 : -1}
          >
            Checkout
          </button>
        </div>
      </aside>
    </section>
  );
};

export default CottonParatha;